define('all/hash-monitor',['jquery', 'all/jquery/jquery.ba-hashchange'], function($) {
	'use strict';

	var listeners = [];
    var OLD_URL = top.location.href;

	$(window).hashchange(function(e) {
        if (typeof(e.originalEvent.newURL) === 'undefined') {
            e.originalEvent.newURL = top.location.href;
            e.originalEvent.oldURL = OLD_URL;

            OLD_URL =  e.originalEvent.newURL;
        }

        for(var i = 0; i < listeners.length; i++) {
			listeners[i].call(undefined, e);
		}
	});

	return {
		addListener: function(listener) {
			listeners.push(listener);
			listener.call(undefined);
		},
		removeListener: function(listener){
			var index = $.inArray(listener, listeners);
			if ( index > 0 ){
				listeners.splice(index, 1);
			}
		}
	};
});

